export default "__VITE_ASSET__df3e5353__"